module.exports = __webpack_public_path__ + "static/img/banner.d4edc8e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/solutions/safetyhelmet/banner.png
// module id = Id18
// module chunks = 12